// src/Login.jsx
import React, { useEffect } from "react";
import { GoogleAuthProvider, signInWithPopup, onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { useNavigate } from "react-router-dom";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u) navigate("/", { replace: true });
    });
    return () => unsub();
  }, [navigate]);

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });
      await signInWithPopup(auth, provider);
      navigate("/", { replace: true });
    } catch (error) {
      console.error("❌ Google login error:", error);
      alert("Login failed: " + error.message);
    }
  };

  return (
    <Box sx={{ display: "grid", placeItems: "center", minHeight: "100vh", bgcolor: "#fafafa", p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 420, width: "100%" }} elevation={0}>
        <Stack spacing={2} alignItems="center">
          <Typography variant="h5" fontWeight={700}>Admin Login</Typography>
          <Typography sx={{ opacity: 0.8, textAlign: "center" }}>
            Sign in with Google to manage hymns.
          </Typography>
          <Button
            onClick={handleGoogleLogin}
            variant="contained"
            size="large"
            sx={{ mt: 1, textTransform: "none", fontWeight: 700 }}
          >
            Continue with Google
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
